import './css/ModelCard.css'

const ModelCard = (props) => {
  const handleClick = e=>{
    props.select(
      {
        "modelname": props.modelname,
        "dimensions": props.dimensions,
        "capacity": props.capacity,
      })    
  }

  return (
      <div 
        className={`model-card ${props.selected?' selected':null}`}
        onClick={handleClick}
        
      >
        <h1 className='text-enhanced'>{props.modelname}</h1>
        <label>platform dimensions</label>
        <h4 className='text-enhanced'>{props.dimensions.depth} x {props.dimensions.width} cm</h4>
        <label>max capacity</label>
        <h5 className='text-enhanced'>{props.capacity} Kg</h5>
      </div>
  )
}
export default ModelCard